const Styles = {
  typography: {
    color: "#1F26C7",
    marginBottom: 25,
    fontSize: 16,
    fontWeight: 500,
  },

  //   gridStyle: {
  //     marginTop: 15,
  //     marginBottom: 15,
  //   },

  typographySecondary: {
    marginTop: 20,
    marginBottom: 20,
  },

  inputField: {
    width: "275px",
  },
  gridContainerStyle: {
    marginTop: 8,
  },
  gridStyle: {
    marginTop: 12,
  },
  gridContainer: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gridTemplateRows: "1fr",
    gridRowGap: "1.5rem",
    gridColumnGap: "1.5rem",
  },
  borderStyle: {
    borderTop: "1px solid #707070",
    paddingTop: "12px",
    marginTop: "-5px",
    width: "300px",
  },
  cancelBtnStyle: {
    marginTop: 5,

    marginLeft: "10px",
  },
  inputStyle: {
    height: 109,
    minWidth: 340,
    maxWidth: 460,
    marginLeft: "10px",
    // border: "1px solid #707070",
    borderRadius: "5px",
  },
  name: {
    gridColumn: "1 / 3",
  },

  zoneLocatorContainer: {
    display: "flex",
    justifyContent: "row",
    alignItems: "center",
    fontSize: "22px",
    marginTop: "12px",
    cursor: "pointer",
  },
};

export default Styles;
